import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CRMAPIserivce from "../../services/CRMAPI-service";
import { CRMState, getOrderLists, onSetIsLoading } from "../reducers/CRM-reducers";

export const getOrdersList = createAsyncThunk(
    'getOrdersList',
    () => {
        return CRMAPIserivce.getOrdersList()
            .then(response => response?.data.data)
    }
)

export const CrmSlice = createSlice({
    name: "CRMSlice",
    initialState: {
        lists: [],
        isLoading: false
    } as CRMState,
    reducers: {
        setIsLoading: ((state, action) => onSetIsLoading(state, action.payload))
    },
    extraReducers: (builder) => {
        builder.addCase(getOrdersList.fulfilled, (state, action) => getOrderLists(state, action.payload));
    }
})

export default CrmSlice.reducer;
export const { setIsLoading } = CrmSlice.actions;

